import axios from '@/utils/apiClient'

export function cmsTextEditUrl(textId) {
  const base = `${window.location.origin}${window.location.pathname}`.replace(/\/$/, '')
  // return `${base}/#/texts/edit/${textId}`
  return `${window.location.origin}/texts/edit/${textId}`
}

export function htmlToPlainText(html) {
  if (!html) return ''
  const documentNode = new DOMParser().parseFromString(html, 'text/html')
  documentNode.querySelectorAll('br').forEach(br => br.replaceWith('\n'))
  documentNode.querySelectorAll('p, li, div, h1, h2, h3, h4').forEach(node => {
    node.appendChild(documentNode.createTextNode('\n'))
  })
  return (documentNode.body.textContent || '')
    .replace(/\n[ \t]+/g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim()
}

export function textCoverageStatus(artwork) {
  const texts = artwork.artwork_texts || []
  if (texts.length === 0) return 'No text'
  if (!texts.some(text => text.id === artwork.representative_text_id)) {
    return 'No public text'
  }
  return 'Public text selected'
}

export async function loadTextReviewData(artworks, apiServer, onProgress) {
  const summaries = []
  artworks.forEach(artwork => {
    ;(artwork.artwork_texts || []).forEach(text => summaries.push({ artwork, text }))
  })

  const loadedById = {}
  let completed = 0
  const queue = [...summaries]
  const workers = Array.from({ length: Math.min(6, queue.length) }, async () => {
    while (queue.length) {
      const item = queue.shift()
      if (!loadedById[item.text.id]) {
        const response = await axios.get(`${apiServer}/artwork_texts/${item.text.id}.json`)
        loadedById[item.text.id] = response.data
      }
      completed += 1
      if (onProgress) onProgress(completed, summaries.length)
    }
  })
  await Promise.all(workers)

  return artworks.map(artwork => ({
    artwork,
    status: textCoverageStatus(artwork),
    texts: (artwork.artwork_texts || []).map(summary => ({
      ...summary,
      ...loadedById[summary.id],
      isPublic: artwork.representative_text_id === summary.id,
      editUrl: cmsTextEditUrl(summary.id),
    })),
  }))
}



// WEBPACK FOOTER //
// ./src/utils/textReviewExport.js